import React from 'react';
import { Link } from 'react-router-dom';
import PublicNavbar from '../components/PublicNavbar';
import PublicFooter from '../components/PublicFooter';
import { Shield, FileText, AlertTriangle } from 'lucide-react';

const PoliciesPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="policies-page">
      <PublicNavbar />

      {/* Header */}
      <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            Policies &amp; Legal
          </h1>
          <p className="text-lg text-blue-100">
            Privacy Policy, Terms of Use, and Disclaimer
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Privacy Policy */}
          <div className="mb-16">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                <Shield className="w-6 h-6 text-blue-900" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Privacy Policy</h2>
            </div>
            <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-200">
              <p className="text-gray-700 leading-relaxed mb-4">
                BlueLock Transport LLC collects applicant and user information solely for recruiting, 
                onboarding, and operational purposes.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Information is not sold or shared outside of business, regulatory, or contractual 
                necessity. Access to data is restricted and managed in accordance with applicable regulations.
              </p>
            </div>
          </div>

          {/* Terms of Use */}
          <div className="mb-16">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                <FileText className="w-6 h-6 text-blue-900" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Terms of Use</h2>
            </div>
            <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-200">
              <p className="text-gray-700 leading-relaxed mb-4">
                This website is provided for informational and operational purposes.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Submission of information does not constitute employment or guarantee of engagement. 
                All services and relationships are governed by executed written agreements.
              </p>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mb-16">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center">
                <AlertTriangle className="w-6 h-6 text-amber-700" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Disclaimer</h2>
            </div>
            <div className="bg-amber-50 rounded-2xl p-6 md:p-8 border border-amber-200">
              <p className="text-gray-700 leading-relaxed mb-4">
                BlueLock Transport LLC does not guarantee income, freight availability, or lane assignment.
              </p>
              <p className="text-gray-700 leading-relaxed">
                All operations are subject to regulatory, insurance, and contractual requirements.
              </p>
            </div>
          </div>

          {/* Contact */}
          <div className="text-center pt-8 border-t border-gray-200">
            <p className="text-gray-600 mb-4">
              Questions about our policies?
            </p>
            <Link
              to="/faq"
              className="text-blue-900 font-medium hover:text-blue-700"
            >
              View our FAQ
            </Link>
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
};

export default PoliciesPage;
